var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3 42q-2.05 0-3.575-1.225Q33.2 39.55 32.8 37.8H22.15q-3.3 0-5.475-2.175T14.5 30.15q0-3.3 2.175-5.475T22.15 22.5H26q2.05 0 3.35-1.3 1.3-1.3 1.3-3.35t-1.3-3.35q-1.3-1.3-3.35-1.3H15.2q-.45 1.75-1.95 2.975T9.7 17.4q-2.4 0-4.05-1.65T4 11.7q0-2.4 1.65-4.05T9.7 6q2.05 0 3.55 1.225T15.2 10.2H26q3.3 0 5.475 2.175t2.175 5.475q0 3.3-2.175 5.475T26 25.5h-3.85q-2.05 0-3.35 1.3-1.3 1.3-1.3 3.35t1.3 3.35q1.3 1.3 3.35 1.3H32.8q.45-1.75 1.95-2.975T38.3 30.6q2.4 0 4.05 1.65T44 36.3q0 2.4-1.65 4.05T38.3 42ZM9.7 14.4q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q10.85 9 9.7 9t-1.925.775Q7 10.55 7 11.7t.775 1.925q.775.775 1.925.775Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.d08efe7ff4ff7bd11d66d2191b9fe4b2.svg";
export { ForwardRef as ReactComponent };